import * as React from 'react';
import classNames from 'classnames';
import {Flex, Text} from '..';
import style from './section.scss';
import {NOOP} from '../utilities';

type SectionElementProps = JSX.IntrinsicElements['div'];

export interface SectionProps extends SectionElementProps {
  title?: string;
  renderTopButton?: () => React.ReactNode|void;
}

export function Section({
  title = '',
  children,
  renderTopButton = NOOP,
  className = '',
  ...restProps
}: SectionProps) {
  const contents = title ? (
    <div className={style.content}>
      {children}
    </div>
  ) : children;

  const header = title ? (
    <Flex
      className={style.header}
      alignItems="center"
      justifyContent="space-between"
    >
      <Text
        type="h5"
        text={title}
        style={{marginBottom: 0}}
      />
      {renderTopButton()}
    </Flex>
  ) : null;

  return (
    <section className={classNames(style.container, className)} {...restProps}>
      <React.Fragment>
        {header}
        {contents}
      </React.Fragment>
    </section>
  );
}
